// import API from '../../api/api';
import React, { Component } from "react";
import "../../styles/css/footer/footer.css";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="footer-main-wrapper">
        <div className="footer">
          <div className="footer-logo">
            <img
              src="/static/images/titlesurvlogo.png"
              alt="survey source logo"
            />
          </div>
          <div className="list">
            <span>About</span>

            <ul>
              <li>Privacy Policy</li>
              <li>Terms of Service</li>
              <li>Survey Policy</li>
              <li>Title company Policy</li>
              <li>FAQ</li>
            </ul>
          </div>
          <div className="list">
            <span>Learn More</span>
            <ul>
              <li>Become a Title company</li>
              <li>Become a Surveyor</li>
            </ul>
          </div>
          <div className="list">
            <span>Contact</span>
            <ul>
              <li>
                {" "}
                <a href="mailto:terry@surveysource.com" target="_blank">
                  terry@surveysource.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p> Survey Source® is a registered Trademark of Survey Source </p>{" "}
          <p> Copyright© 2019 Survey Source </p>{" "}
        </div>{" "}
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js